<script>
    import { changeData } from '@/scripts/tools.js';
    import constants from '@/constants';
    import FilterTypeDescription from '@/components/page-filter-edit/FilterTypeDescription.vue';

    export default {
        data() {
            return {
                errorText: '',
            }
        },
        components: {
            FilterTypeDescription: FilterTypeDescription,
        },
        computed: {
            filterType() {return constants.FILTER_TYPE},
            editData() {return this.$store.getters.FILTER_DATA_EDIT},
        },
        methods: {
            async updateData(event, fieldName, isCheckBox = false) {
                this.errorText = await changeData(
                    event, fieldName, 'FILTER_DATA_EDIT_UPDATE', 'CHECK_FILTER_EDIT', isCheckBox
                );
            },
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name</label>
        <input 
            :value="editData['name']"
            @change="updateData($event, 'name')"
            type="text"
            class="right_input mt_5 mb_10"
        >

        <label>Description:</label>
        <input
            :value="editData['description']"
            @change="updateData($event, 'description')"
            type="text"
            class="right_input mt_5 mb_10"
        >

        <label>Filter Type:</label>
        <select
            :value="editData['filter_type']"
            @change="updateData($event, 'filter_type')"
            class="right_input mt_5 mb_10"
        >
            <option
                v-for="(filterTypeValue, filterTypeIndex) in filterType" :key="filterTypeIndex"
                :value="filterTypeValue['id']"
            >
                {{ filterTypeValue['name'] }}
            </option>
        </select>

        <FilterTypeDescription />

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>